import {ReactNode, useEffect, useState} from 'react';
import {useManualTimeout} from '../../../../hooks/useManualTimeout/useManualTimeout';
import {
  defaultEntranceAnimationDuration,
  durationPerCharInMs,
  maxDurationInMs,
  minDurationInMs,
} from '../constants';
import {getTextLeaves} from '../getTextLeaves';

export const useAutoHide = ({
  closeCallback,
  content,
  isDisabled,
}: {
  closeCallback: VoidFunction;
  content: ReactNode;
  isDisabled?: boolean;
}) => {
  const [hasTimerStarted, setHasTimerStarted] = useState(false);
  const contentLength = getCountTextCharacters(content);
  const contentTotalDuration = contentLength * durationPerCharInMs;
  const autoHideDelayTime = Math.max(
    minDurationInMs,
    Math.min(contentTotalDuration, maxDurationInMs),
  );
  // starts the counts of the auto hide, after the animation has finished
  const autoHideTimePlusAnimationTime = isDisabled
    ? null
    : autoHideDelayTime + defaultEntranceAnimationDuration;
  const [hasTimedOut, runTimer] = useManualTimeout(
    autoHideTimePlusAnimationTime,
  );

  useEffect(() => {
    if (isDisabled) {
      return;
    }

    runTimer();
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setHasTimerStarted(true);
  }, [runTimer]);

  useEffect(() => {
    if (hasTimerStarted && hasTimedOut) {
      closeCallback();
      // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
      setHasTimerStarted(false);
    }
  }, [hasTimedOut, closeCallback, hasTimerStarted]);
};

export const getCountTextCharacters = (content: ReactNode) =>
  getTextLeaves(content).reduce<number>(
    (count, leaf) => (typeof leaf === 'string' ? count + leaf.length : count),
    0,
  );
